import React from "react";
import { Link, useLocation } from "react-router-dom";

const Sidebar = () => {
  const location = useLocation();

  const navItems = [
    { name: "عرض المنتجات", path: "/admin/products", icon: "📦" },
    { name: "إضافة منتج", path: "/admin/add-product", icon: "➕" },
    { name: "الطلبات", path: "/admin/orders", icon: "🛒" },
  ];

  return (
    <div style={styles.sidebar}>
      <h2 style={styles.title}>لوحة التحكم ⚙️</h2>
      <ul style={styles.navList}>
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <li key={item.path} style={styles.navItem}>
              <Link
                to={item.path}
                style={{
                  ...styles.link,
                  ...(isActive ? styles.activeLink : {}),
                }}
              >
                <span style={styles.icon}>{item.icon}</span>
                {item.name}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

const styles = {
  sidebar: {
    width: "250px",
    background: "linear-gradient(180deg, #1e3a8a, #3b82f6)",
    color: "white",
    padding: "25px 20px",
    height: "100vh",
    position: "sticky",
    top: 0,
    fontFamily: "Tahoma, sans-serif",
    boxShadow: "2px 0 8px rgba(0,0,0,0.1)",
  },
  title: {
    textAlign: "center",
    marginBottom: "30px",
    fontSize: "22px",
    borderBottom: "1px solid rgba(255,255,255,0.3)",
    paddingBottom: "10px",
  },
  navList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
  },
  navItem: {
    marginBottom: "10px",
  },
  link: {
    color: "white",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    padding: "10px 15px",
    borderRadius: "8px",
    transition: "background 0.3s",
  },
  activeLink: {
    backgroundColor: "#2563eb",
    fontWeight: "bold",
    color: "#ffd700",
  },
  icon: {
    marginLeft: "8px",
    fontSize: "18px",
  },
};

export default Sidebar;